import { NativeScrollEvent, NativeSyntheticEvent } from 'react-native';

import { NativeTopBarStyle } from './NativeHelpers';

// Hysteresis thresholds to prevent rapid oscillation
const TRANSPARENT_TO_DEFAULT_THRESHOLD = 15; // Switch to default when scrolling down past this
const DEFAULT_TO_TRANSPARENT_THRESHOLD = 5; // Switch to transparent when scrolling up past this (back towards top)

export const updateOnScrollTopBarStyle = (
  event: NativeSyntheticEvent<NativeScrollEvent>,
  topBarStyle?: NativeTopBarStyle,
  onScrollTopBarStyle?: NativeTopBarStyle,
  currentStyle?: NativeTopBarStyle // Add current style parameter for hysteresis
): NativeTopBarStyle | undefined => {
  if (topBarStyle && topBarStyle !== NativeTopBarStyle.Hidden) {
    const contentOffsetY = event.nativeEvent.contentOffset.y;

    // Use hysteresis to prevent rapid switching
    if (currentStyle === topBarStyle) {
      // Currently transparent, switch to default only when scrolling down significantly
      if (contentOffsetY > TRANSPARENT_TO_DEFAULT_THRESHOLD) {
        return onScrollTopBarStyle;
      }

      return topBarStyle;
    } else {
      // Currently default, switch to transparent when scrolling back up towards top
      if (contentOffsetY < DEFAULT_TO_TRANSPARENT_THRESHOLD) {
        return topBarStyle;
      }

      return onScrollTopBarStyle;
    }
  }
};
